import React, { useState, useEffect, useContext } from 'react';
import splitbee from "@splitbee/web"
import GlobalStateContext from './globalState';
import { logEvent } from '../../utils/logger';
import Translate from './translate';

const CookieBanner = () => {
  const { isCookieEnabled, setCookieEnabled } = useContext(GlobalStateContext);
  const [isCookieAcknowledged, setIsCookieAcknowledged] = useState(true);

  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      const cookiesAcceptedValue = localStorage.getItem('cookiesAccepted');

      if(cookiesAcceptedValue === null) {
        setIsCookieAcknowledged(false);
        return;
      }

      setCookieEnabled(cookiesAcceptedValue === 'true');
      setIsCookieAcknowledged(true)
    }
  }, []);

  const handleAcceptCookies = () => {
    logEvent("Cookie Banner Accepted")
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('cookiesAccepted', 'true');
    }
    setCookieEnabled(true);
    setIsCookieAcknowledged(true);
  };

  const handleDeclineCookies = () => {
    logEvent("Cookie Banner Declined")
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('cookiesAccepted', 'false')
    }
    setCookieEnabled(false);
    setIsCookieAcknowledged(true);
  };

  const handleDismissCookies = () => {
    logEvent("Cookie Banner Dismissed")
    setCookieEnabled(false);
    setIsCookieAcknowledged(true);
  };

  if (isCookieAcknowledged) {
    return <></>;
  }

  return (
    <div className="bg-[#F0EEF6] text-[#27004F] p-6 fixed bottom-0 left-0 w-full z-50">
      <div className="flex flex-col md:flex-row justify-between items-left md:items-center gap-8 w-5/6">
        <div className="text-sm py-2 md:flex-grow cursor-pointer">
          <p className="font-extrabold mb-2 text-xl">
            <Translate id="cookiebanner.privacyNotice" foldername="general" filename="cookiebanner" />
          </p>
          <Translate id="cookiebanner.cookieUsage" foldername="general" filename="cookiebanner" />{' '}
          <span className="text-[#643ADA] font-bold " onClick={() => (location.href = `/privacy-policy`)}>
            <Translate id="cookiebanner.privacyPolicy" foldername="general" filename="cookiebanner" />
          </span>
        </div>
        <div className="flex items-left md:items-center space-x-2 gap-4">
          <button className="bg-[#FFCA1D] text-[#483187] font-bold py-1 px-3 rounded" onClick={handleAcceptCookies}>
            <Translate id="cookiebanner.accept" foldername="general" filename="cookiebanner" />
          </button>
          <button className="text-[#27004F] hover:text-gray-300 font-bold" onClick={handleDeclineCookies}>
            <Translate id="cookiebanner.decline" foldername="general" filename="cookiebanner" />
          </button>
          <button className="text-[#fd9b79] md:ml-2" onClick={handleDismissCookies}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-5 h-5"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;